import { ApplicationInsightsModule } from '@abb-procure/application-insights';
import {
  dateInterceptor,
  fingerprintInterceptor,
  impersonationInterceptor,
  wafInterceptor,
} from '@abb-procure/common';
import { MAP_AUTH_OPTIONS } from '@abb-procure/map';
import { concurrentSessionInterceptor } from '@abb-procure/sessions';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
  withXhr,
} from '@angular/common/http';
import {
  enableProdMode,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import {
  provideRouter,
  withComponentInputBinding,
  withDisabledInitialNavigation,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
} from '@angular/router';
import { MsalModule } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { enableDevValidations } from 'ag-grid-community';
import {
  AllEnterpriseModule,
  LicenseManager,
  ModuleRegistry,
} from 'ag-grid-enterprise';
import { provideHighcharts } from 'highcharts-angular';
import { quicklinkProviders, QuicklinkStrategy } from 'ngx-quicklink';
import { APP_PROVIDERS } from './app/app-module-providers';
import { App } from './app/app.component';
import { routes } from './app/app.routing';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

ModuleRegistry.registerModules([AllEnterpriseModule]);
LicenseManager.setLicenseKey(environment.agGridLicenceKey);

if (!environment.production) {
  enableDevValidations();
}

bootstrapApplication(App, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      ApplicationInsightsModule.forRoot({
        instrumentationKey: environment.instrumentationKey,
        // @see https://stackoverflow.com/questions/58109846/how-to-programmatically-add-correlation-headers-to-application-insights-angular
        disableFetchTracking: false,
        enableAutoRouteTracking: true,
      }),
      MsalModule,
      NgSelectModule,
      MatNativeDateModule,
    ),
    { provide: MAP_AUTH_OPTIONS, useValue: environment.mapOptions.authOptions },
    ...APP_PROVIDERS,
    provideZoneChangeDetection(),
    provideHttpClient(
      withXhr(),
      withInterceptors([
        dateInterceptor,
        concurrentSessionInterceptor,
        impersonationInterceptor,
        fingerprintInterceptor,
        wafInterceptor,
      ]),
      withInterceptorsFromDi(),
    ),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      }),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
      !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
        ? withEnabledBlockingInitialNavigation()
        : withDisabledInitialNavigation(),
      withPreloading(QuicklinkStrategy),
    ),
    quicklinkProviders,
    provideHighcharts(),
  ],
}).catch((err) => {
  console.error(err);
});
